<div class="frozen-columns">
  <div class="list-item-action-cell">
    <button
      *ngIf="item.isNew !== true && (!isDeployedList || canEditProperties)"
      type="button"
      class="list-selection-checkbox"
      aria-role="checkbox"
      data-test="select-list-item"
      (click)="toggleSelection()"
      [attr.aria-checked]="isSelected"
      aria-label="Select this item"
    >
      <i class="cc-icon cc-icon-check cc-icon-sm" aria-hidden="true"></i>
    </button>
    <!-- Note that the *button* below is aria-hidden, since extra screen space isn't relevant for screen readers -->
    <!-- DON'T follow this pattern without a good reason. use the above (aria-hidden on the icon only) -->
    <button
      type="button"
      (click)="toggleExpand()"
      class="expand-row-button"
      aria-hidden="true"
      *ngIf="item.isNew !== true"
    >
      <em class="cc-icon cc-icon-arrow-right-small"></em>
    </button>
  </div>
  <div
    class="list-item-property list-item-name-container"
    [class.editing]="item.editing === true"
    [class.new]="item.isNew === true"
  >
    <ng-container *ngIf="item.editing === true">
      <input
        type="text"
        class="list-item-name-input"
        [value]="item.value"
        *ngIf="!isDeployedList"
        (blur)="editItem($event.target.value)"
        (keyup.esc)="cancelEdit()"
        (keyup.enter)="editItem($event.target.value)"
        placeholder="Type item name..."
        ccFocus
      />
      <cc-list-typeahead
        class="sm-w-full"
        [list]="list"
        [parentId]="parentId"
        (listDeployed)="onListDeployed($event)"
        (cancel)="cancelEdit()"
        *ngIf="isDeployedList"
      ></cc-list-typeahead>
    </ng-container>
    <ng-container *ngIf="item.editing !== true">
      <div
        *ngIf="!isDeployedList"
        (click)="onSetEditMode(true)"
        class="list-item-name-display non-deployed"
        data-test="edit-item-name"
      >
        {{ item.value }}
      </div>
      <div *ngIf="isDeployedList" class="list-item-name-display deployed">
        {{ item.value }}
      </div>
    </ng-container>
  </div>
</div>
<div
  class="list-item-property list-style-property"
  [class.editing]="item.editing === true"
  [class.new]="item.isNew === true"
>
  <cc-style-color-picker
    [(style)]="item.style"
    (styleChange)="onStyleUpdated($event)"
    [defaultStyle]="styleVariants.None"
    [disabled]="isDeployedList"
  ></cc-style-color-picker>
</div>
<ng-container *ngIf="item.isNew !== true && list.properties">
  <cc-list-property
    tabindex="0"
    *ngFor="
      let _ of beforeAddPropertyIterator;
      index as index;
      trackBy: trackByBeforeAddPropertyColumn.bind(this)
    "
    [item]="item"
    [editable]="!isDeployedList"
    [listItemPropertyMap]="itemPropertyTypes"
    [propertyHeader]="list.properties[index]"
    (propertyUpdated)="updateCell($event, index)"
    [companyId]="folder.company?.id"
    [projectId]="folder.project?.id"
    [listId]="list.id"
    (focusin)="!isDeployedList && onInteract(list.properties[index + addPropertyIndex])"
  ></cc-list-property>
  <div class="empty-list-property" *ngIf="addPropertyIndex !== null"></div>
  <cc-list-property
    *ngFor="
      let _ of afterAddPropertyIterator;
      index as index;
      trackBy: trackByAfterAddPropertyColumn.bind(this)
    "
    [item]="item"
    [editable]="!isDeployedList"
    [listItemPropertyMap]="itemPropertyTypes"
    [propertyHeader]="list.properties[index + addPropertyIndex]"
    (propertyUpdated)="updateCell($event, index + addPropertyIndex)"
    [companyId]="folder.company?.id"
    [projectId]="folder.project?.id"
    [listId]="list.id"
    (focusin)="!isDeployedList && onInteract(list.properties[index + addPropertyIndex])"
  ></cc-list-property>
</ng-container>
